export const convertCurrencyToNumber = (currencyString) => {
  const cleanedString = `${currencyString}`.replace(/[^0-9.]/g, '');
  const floatValue = parseFloat(cleanedString);
  return floatValue;
};
